// we pass the global `analytics` in separately to assist us in stubbing easily with jest
export function ensureCslUserId(analytics) {
  // If the user_id saved in Segment's cookie/localStorage
  // doesn't match our member ID prefix, null the user ID so it is not
  // included with page or event tracking calls.

  // This can be wrong when Segment is also in use with a different identifier elsewhere
  // on the domain.
  if (analytics.user().id() !== null && !analytics.user().id().startsWith('csl-')) {
    analytics.user().id(null)
  }
}

// Wrap with analytics.ready() so that analytics.user() is available.
if (window.analytics) {
  window.analytics.ready(() => ensureCslUserId(window.analytics))
}
